
export default {
  name: 'AcademyBanner',
}
